import React from 'react'
import {sanitizedInput} from '../../utils'
import ClearableFieldWrapper from '../ClearableFieldWrapper/ClearableFieldWrapper'

interface PickupInstructionsTextareaProps {
  value: string
  onChange: (value: string) => void
  isDisabled: boolean
}

const maxLength = 150

const PickupInstructionsTextarea = ({
  value,
  onChange,
  isDisabled,
}: PickupInstructionsTextareaProps) => {
  return (
    <div className="mb-5">
      <label
        htmlFor="pickupInstructions"
        className="block text-xs text-sky-500 dark:text-sky-400 mb-2"
      >
        Special notes for our drivers
      </label>
      <ClearableFieldWrapper
        showClear={value.length > 0 && !isDisabled}
        hasError={false}
        onClear={() => onChange('')}
        label="Special notes for our drivers"
        variant="top-right"
      >
        <textarea
          className={[
            'border text-sm rounded p-2 text-gray-700 dark:text-slate-200',
            'border-gray-300 dark:border-slate-600 dark:bg-slate-900/60 leading-[1.3] focus:outline-none',
            'focus:border-sky-500 dark:focus:border-sky-400 w-full h-[100px] resize-none pr-8',
          ].join(' ')}
          id="pickupInstructions"
          name="pickupInstructions"
          placeholder="Pickup instructions..."
          inputMode="text" // codeCommentsOpenMobileVirtualKeyboardOnAutoFocus
          tabIndex={0}
          maxLength={maxLength} // codeCommentsOpenMobileVirtualKeyboardOnAutoFocus
          value={value}
          onChange={(e) => onChange(sanitizedInput(e.target.value))}
          disabled={isDisabled}
        />
      </ClearableFieldWrapper>
      <div
        className={`text-xs text-gray-500 dark:text-slate-400 mt-1 flex justify-end ${value.length === maxLength ? 'font-bold' : ''}`}
      >
        <p>
          {value.length}/{maxLength}
        </p>
      </div>
    </div>
  )
}

export default React.memo(PickupInstructionsTextarea)
